import { TM } from "@litres-libs/tracker-manager";
import type { ISearchResultItem } from "./types";

interface ISearchSuggestionItemParams {
  query: string;
  rowNumber: number;
}

export const trackSearchSuggestionItem = (
  item: ISearchResultItem,
  { query, rowNumber }: ISearchSuggestionItemParams
) => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "suggestion_click",
    params: {
      // https://docs.litres.ru/pages/viewpage.action?pageId=98630557
      // query — поисковый запрос пользователя
      query,
      suggestion_text: item.value,
      suggestion_row_number: rowNumber,
    },
  });
};

export const trackSearchHistoryItem = (item: ISearchResultItem) => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "suggestion_history_click",
    params: {
      // https://docs.litres.ru/pages/viewpage.action?pageId=98630557
      // query — текст поисковой подсказки
      query: item.value,
    },
  });
};
